import React, { Component } from 'react';
import ImageUploader from './../../../../commons/ImageUploader.js';
import ImageViewer from './../../../../commons/ImageViewer.js'
import ProductInfo from './ProductInfo.js';
import InwardingApiHandler from './../../InwardingApiHandler.js';
import Dialog from '@material-ui/core/Dialog';
import barcode_error from './../../../../assets/img/barcode_error.svg';
import InputFloating from './../../../../commons/InputFloating.js';
import MobLoader from './../../../../commons/MobLoader.js';
import ErrorBox from './../../../../commons/ErrorBox.js';

export default class ProductBarcodeMapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			barcodeData: {},
			shouldAskForBarcodeVerification: false,
			scannedBarcode: null,
			barcodeMatchStatus: null,
			noProductFoundWithBarcode: false,
			loading: false
		}
	}

	componentWillMount() {
		const { vinv, product, palletId, scannedBarcode, barcodeMatchStatus, allowedProducts, receivedQuantity } = this.props.location.state;
		this.setState({ selectedProduct: product, vinv: vinv, palletId: palletId, scannedBarcode: scannedBarcode, barcodeMatchStatus: barcodeMatchStatus, allowedProducts: allowedProducts, receivedQuantity: receivedQuantity });
	}


	closeError = () => {
		this.setState({ error: null })
	}

	handleBarcodeSearchResponse = (resp, barcode) => {
		const { allowedProducts, selectedProduct } = this.state;
		// The barcode lookup now returns ALL SKUs mapped to the barcode (a single barcode can map to
		// many JPINs). Tolerate both the new list shape and the legacy single-object shape.
		const skus = Array.isArray(resp) ? resp : (resp && resp.jpin ? [resp] : []);
		if (skus.length > 0) {
			const scannedJpins = new Set(skus.map(sku => sku.jpin).filter(Boolean));
			if (scannedJpins.has(selectedProduct.productInfoResponse.jpin)) {
				this.setState({ barcodeMatchStatus: 'PRESENT_IN_PO_CORRECT_MATCH', scannedBarcode: barcode },
					() => {
						this.addForVerification();
					})
			} else {
				const matchesAnotherPoProduct = allowedProducts.some(item =>
					scannedJpins.has(item.productListingInformation.productInfoResponse.jpin)
				);
				const status = matchesAnotherPoProduct ? 'PRESENT_IN_PO_WRONG_MATCH' : 'NOT_IN_PO';
				this.setState({ noProductFoundWithBarcode: true, scannedBarcode: barcode, barcodeMatchStatus: status });
			}

		} else {
			this.setState({ noProductFoundWithBarcode: true, scannedBarcode: barcode, barcodeMatchStatus: 'NOT_FOUND' })
		}
	}

	searchBarCode = (barcode) => {
		this.setState({ loading: true });
		InwardingApiHandler.searchBarCode(barcode)
			.then(resp => {
				this.handleBarcodeSearchResponse(resp, barcode)
			}).catch(error => {
				this.setState({ error: error.error.error })
			}).finally(resp => {
				this.setState({ loading: false });
			})
	}

	onKeyUp = (e) => {
		if (e.keyCode === 13 || e.which === 13) {
			let barcode = e.target.value;
			if (!isNaN(barcode)) {
				this.searchBarCode(barcode);
			}
		}
	}

	closeNotFoundErrorBox = () => {
		this.setState({ noProductFoundWithBarcode: false, shouldAskForBarcodeVerification: true })
	}

	handleImageUploadResponse = (resp, type) => {
		let barcodeData = { ...this.state.barcodeData };
		barcodeData[type] = resp;
		this.setState({ barcodeData });
	}

	removeImage = (type) => {
		let barcodeData = { ...this.state.barcodeData };
		barcodeData[type] = null;
		this.setState({ barcodeData });
	}

	addForVerification = () => {
		//debugger;
		const { selectedProduct, vinv, palletId, scannedBarcode, barcodeData, barcodeMatchStatus, receivedQuantity } = this.state;
		this.props.history.push({
			pathname: '/Inwarding/ProductDetails',
			state: {
				vinv: vinv,
				product: selectedProduct,
				palletId: palletId,
				scannedBarcode: scannedBarcode,
				barcodeData: barcodeData,
				barcodeMatchStatus: barcodeMatchStatus,
				receivedQuantity: receivedQuantity
			}
		});
	}

	isValidated = () => {
		let barcodeData = { ...this.state.barcodeData };
		if (barcodeData.frontImage && barcodeData.barcodeImage) {
			return true;
		}
		return false;
	}


	backButtonClicked = () => {
		window.history.back();
	}

	getHeaderBox = () => {
		return (<div className="header-name-bar">
			<div className="row">
				<div className="col-xs-1">
					<div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={this.backButtonClicked}><i className="fas fa-arrow-left"></i></div>
				</div>
				<div className="col-xs-11">
					<div className="header-page-name">
						<div>Verify Product Barcode</div>
					</div>
				</div>
			</div>
		</div>)
	}


	getProductNotFoundRender = () => {
		return (<div style={{ padding: '20px', textAlign: 'center' }}>
			<div><img src={barcode_error} alt="product not found" /></div>
			<div className="top-twenty"><div className="error-head-text">No Product Found</div></div>
			<div className="top-ten"><div className="error-desc-text"><div>The barcode didn’t match with</div> <div>this product.</div> <div>Add New Barcode</div></div></div>
			<div className="top-thirty"><button className="btn btn-big-norm" onClick={this.closeNotFoundErrorBox}>Okay</button></div>
		</div>);
	}

	render() {
		const { selectedProduct, barcodeData, scannedBarcode, noProductFoundWithBarcode, shouldAskForBarcodeVerification, error, loading } = this.state;
		return (<div>
			<div className="visible-xs visible-sm">{this.getHeaderBox()}</div>
			<div style={{ padding: '10px' }}>
				<div className={this.isValidated() ? "lw-btn dtl-box" : "dtl-box"}>

					<ProductInfo product={selectedProduct} />
					<div className="top-twenty">
						{(!shouldAskForBarcodeVerification) ?
							<InputFloating type="text" label="Product Barcode" name="actualProductBarcode" value={scannedBarcode} onKeyUp={this.onKeyUp} />
							:
							<div>
								<div className="img-ttl" style={{ opacity: '0.7' }}>Scanned Barcode : </div>
								<div className="img-ttl" style={{ fontSize: '20px' }}>{scannedBarcode}</div>
							</div>
						}
					</div>
					{(shouldAskForBarcodeVerification) ?
						<div>
							<div className="top-twenty">
								<div className="img-ttl">Product Image<sup className="mand">*</sup></div>
								<div className="img-instrctn">(Take photo of <span className="bold-font">FRONT SIDE</span> of the product)</div>
								<div className="top-ten" style={{ border: '1px solid #dfdfdf' }}>
									{(barcodeData.frontImage) ?
										<div className="centralized">
											<ImageViewer src={barcodeData.frontImage} alt="front-image" style={{ width: '80%' }} type={"frontImage"} shouldRemove={true} onRemove={this.removeImage} />
										</div>
										:
										<ImageUploader url={"inwarding/upload"} type={"frontImage"} handleUploadResponse={this.handleImageUploadResponse} />
									}
								</div>

							</div>
							<div className="top-twenty">
								<div className="img-ttl">Barcode Image<sup className="mand">*</sup></div>
								<div className="top-ten" style={{ border: '1px solid #dfdfdf' }}>
									{(barcodeData.barcodeImage) ?
										<div className="centralized">
											<ImageViewer src={barcodeData.barcodeImage} alt="barcode-image" style={{ width: '80%' }} type={"barcodeImage"} shouldRemove={true} onRemove={this.removeImage} />
										</div>
										:
										<ImageUploader url={"inwarding/upload"} type={"barcodeImage"} handleUploadResponse={this.handleImageUploadResponse} />
									}
								</div>
							</div>
						</div> : null
					}
				</div>
			</div>
			{(this.isValidated()) ?
				<div className="bottom-btn">
					<button className="btn btn-big-fin" onClick={this.addForVerification}>Send for Verification & Proceed</button>
				</div> : null
			}
			<Dialog open={noProductFoundWithBarcode} maxWidth="lg" fullWidth={true} onClose={this.closeNotFoundErrorBox} classes={{ 'paper': 'tw-margn-class' }}>
				{this.getProductNotFoundRender()}
			</Dialog>
			{(error) ? <ErrorBox errorText={error} closeError={this.closeError} /> : null}
			{(loading) ? <MobLoader /> : null}
		</div>)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/ProductBarcodeMapper.js